import { Component, OnInit } from '@angular/core';
import { SearchService } from "../search.service";

@Component({
  selector: 'app-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss'],
  standalone: false
})
export class InfoComponent implements OnInit {
  start: number;
  rows: number;
  numFound: number;
  numRetrieved: number;
  qTime: number;
  qTimeSeconds: number;
  date_retrieved: Date | null;
  isLoading: boolean;
  error: any; // Changed from SolrError to any

  constructor(private searchService: SearchService) {
    this.start = 0;
    this.rows = 0;
    this.numFound = 0;
    this.numRetrieved = 0;
    this.qTime = 0;
    this.qTimeSeconds = 0;
    this.date_retrieved = null;
    this.isLoading = false;
    this.error = null;
  }

  ngOnInit(): void {
    this.searchService.currentSearchContext.subscribe(searchContext => {
      this.start = searchContext.start;
      this.rows = searchContext.rows;
    });
    this.searchService.currentResults.subscribe(results => {
      this.numFound = results.numFound;
      this.numRetrieved = results.numRetrieved;
    });
    this.searchService.currentResultHeader.subscribe(header => {
      if (header) {
        this.qTime = header.QTime;
        this.qTimeSeconds = this.qTime / 1000;
        this.date_retrieved = header.date_retrieved;
      }
    });
    this.searchService.currentError.subscribe(error => {
      this.error = error;
    });
    this.searchService.isLoading.subscribe(isLoading => {
      this.isLoading = isLoading;
    });
  }
}
